(function () {
    'use strict';

    angular
        .module('josdaviApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('parameters.info-admin', {
                parent: 'entity',
                url: '/infos-administration',
                title: 'Action Groupées',
                sidebarMeta: {
                    icon: 'glyphicon glyphicon-tower',
                    order: 9
                },
                data: {
                    authorities: ['ROLE_RESPONSABLE_INSCRIPTION', 'ROLE_RESPONSABLE', 'ROLE_ADMIN'],
                    pageTitle: 'josdaviApp.classe.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/info-administrative/info-admin.html',
                        controller: 'InfoAdminController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {}
            });

        $stateProvider
            .state('client-envoie-groupe', {
                parent: 'entity',
                url: '/envoie-en-masse',
                title: 'Envoie Groupés',
                sidebarMeta: {
                    icon: 'glyphicon glyphicon-comment',
                    order: 9
                },
                data: {
                    authorities: ['ROLE_ENVOIE_GROUPE'],
                    pageTitle: 'josdaviApp.classe.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/info-administrative/client-envoie-groupe.html',
                        controller: 'InfoAdminController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {}
            });
    }

})();
